import $ from 'jquery';

function KaijouCtrl() {
  this.$win = $(window);
  this.$target = $('#jukou');
  this.$kaijou = $('#kaijou');
  this.check_or_radio = (this.$target.hasClass('checkbox')) ? ':checkbox' : ':radio';

  this.click = this.click.bind(this);
  this.setup = this.setup.bind(this);
  this.ready = this.ready.bind(this);

  this.init();
}

KaijouCtrl.prototype.init = function () {
  this.$target.find(':radio').on('click', this.click);
  $(window).on('load', this.ready);
}

KaijouCtrl.prototype.click = function (e) {
  const self = this;
  const $this = $(e.currentTarget);
  let data = $this.data('kaijou');

  this.setup($this);

  if (data !== false) {
    let dataSplit = data.split(',');
    // console.log(dataSplit)

    self.$kaijou.find(':radio').each(function () {
      const $self = $(this)
      let val = $self.val();
      let not = $self.data('not');
      $self.prop('disabled', true);
      $self.parent().hide();
      console.log(val)
      $.each(dataSplit, function (i, v) {
        let kaijou = v + '会場';
        if (kaijou === val || v === '動画') {
          $self.prop('disabled', false);

          // if (val === '埼玉' || val === '東京') {
          if (not == 'disable') {
            $self.prop('disabled', true);
            $self.prop('checked', false);
            $self.parent().attr('disabled', '');
          }
          $self.parent().show();
        }
      })
    })

    let $kaijouSubText = $('.kaijouSubText');
    if ($this.val() === '秋期セミナーコースでの受講') {
      $kaijouSubText.html('秋期セミナーコースでの受講');
    } else {
      $kaijouSubText.html('セミナーコースでの受講<br>セミナーコース(2年)での受講');
    }
  }
}

KaijouCtrl.prototype.setup = function (str) {
  const self = this;
  const strVal = str.val();
  const dataKaijou = str.data('kaijou');

  // if (strVal == '通信コースでの受講' || strVal == '速修コースでの受講') {
  if (dataKaijou == false) {
    self.$kaijou.find(self.check_or_radio).prop('disabled', true);
    if (self.$kaijou.hasClass('checkbox')) {
      self.$kaijou.removeClass('checkRequired');
    }
    self.$kaijou.parent().parent().addClass('sokushu-none');
  } else {
    // self.$kaijou.find(self.check_or_radio).prop('disabled', false);
    self.$kaijou.find(self.check_or_radio).each(function () {
      let val = $(this).val();
      let not = $(this).data('not');
      // if (val == '埼玉' || val == '東京') {
      if (not == 'disable') {
        $(this).prop('disabled', true);
        $(this).prop('checked', false);
        $(this).parent().attr('disabled', '');
      } else {
        $(this).prop('disabled', false);
      }
    });
    if (self.$kaijou.hasClass('checkbox')) {
      self.$kaijou.addClass('checkRequired');
    }
    self.$kaijou.parent().parent().removeClass('sokushu-none');
  }
}

KaijouCtrl.prototype.ready = function () {
  const self = this;
  self.$target.find(':radio').each(function () {
    if ($(this).prop('checked')) {
      self.setup($(this))
    }
  })
}

export default KaijouCtrl;